"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PayoutModalHelper = (function () {
    function PayoutModalHelper() {
    }
    PayoutModalHelper.bind = function (payoutNumber) {
        $('.payout-pin').html(payoutNumber);
    };
    ;
    PayoutModalHelper.logErorr = function (error) {
        $('.payout-pin').val(error);
    };
    PayoutModalHelper.openModal = function () {
        $('.payout-modal').modal('show');
    };
    PayoutModalHelper.closeModal = function () {
        $('.payout-modal').modal('hide');
    };
    return PayoutModalHelper;
}());
exports.default = PayoutModalHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/ts/helpers/payout-modal-helper.ts
// module id = 1996
// module chunks = 6